import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayMode, TimeApiService } from 'cbc-shared-lib';
import { cloneDeep } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Sgke121aRequest, Sgke121aResponseInitialhyojiInfo, Sgke122aRequest, Sgke122aResponseSearchresultList, Sgke123aRequest, Sgke123aRequestApprvInfo, Sgke124aRequest, Sgke124aRequestReginf, Szza012aRequest } from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { UsedSgke121aService } from '../../services/used-sgke121a.service';
import { UsedSgke122aService } from '../../services/used-sgke122a.service';
import { UsedSgke123aService } from '../../services/used-sgke123a.service';
import { UsedSgke124aService } from '../../services/used-sgke124a.service';
import { UsedSzza012aService } from '../../../../../sg-ke-shared/services/used-szza012a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke120d',
  templateUrl: './sgke120d.component.html',
  styleUrl: './sgke120d.component.scss'
})
export class Sgke120dComponent implements OnInit, OnDestroy {

  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  private onDestroy$ = new Subject();
  /** 初期表示（新規）APIリクエスト */
  private request121a: Sgke121aRequest;

  /** モード区分_登録 */
  public MODE_CREATE = DisplayMode.create;
  /** モード区分_承認 */
  public MODE_APPROVE = DisplayMode.approve;

  /** モード区分（初期値として登録を設定）*/
  mode: string = this.MODE_CREATE;
  /** 初期表示情報（新規）_検索結果 */
  initialhyojiInfo: Sgke121aResponseInitialhyojiInfo;
  /** 検索結果リスト */
  searchresultList: Array<Sgke122aResponseSearchresultList>;
  /** 報告済過不足額（累計） */
  confirmzumiKafusokuRuikei: number;
  /** 表示過不足額合計 */
  hyojiBalanceSum: number;
  /** 検索条件Form FormGroup */
  searchConditionForm: UntypedFormGroup;
  /** 検索結果表示フラグ */
  showResult: boolean = false;
  /** ダブルクリック押下フラグ */
  dblClickFlg: boolean = false;

  /** 検索APIリクエスト */
  requestSgke122a: Sgke122aRequest;
  /** 業務日付 */
  businessDate: Date;
  /** 業務日付取得APIリクエスト */
  requestSzza012a: Szza012aRequest;

  /**
   * コンストラクタ
   * @param {ActivatedRoute} route 
   * @param {Router} router 
   * @param {UsedSzza012aService} getDateService
   * @param {UsedSgke121aService} initService 
   * @param {UsedSgke122aService} searchService 
   * @param {UsedSgke123aService} approvalService 
   * @param {UsedSgke124aService} reportService 
   * @param {TimeApiService} timeApiServicefb
   * @param {ResponseMsgUtils} responseMsgUtils
   * @param {UntypedFormBuilder} fb 
   * @param {ChangeDetectorRef} cd
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke120dComponent
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public getDateService: UsedSzza012aService,
    public initService: UsedSgke121aService,
    public searchService: UsedSgke122aService,
    public approvalService: UsedSgke123aService,
    public reportService: UsedSgke124aService,
    private timeApiService: TimeApiService,
    public responseMsgUtils: ResponseMsgUtils,
    private fb: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
  ) { }

  /**
   * 初期処理
   * @memberof Sgke120dComponent
   */
  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {

      // 画面遷移元パラメータ取得
      this.mode = params.get('mode');

      // 検索条件Formを初期化
      this.searchConditionForm = this.fb.group({
        requestCommon: new UntypedFormGroup({}),
      });

      // クリア処理
      this.clear(this.searchService.mode != this.mode);
      this.searchService.mode = this.mode;
      // 初期表示情報初期化
      this.initialhyojiInfo = null;

      // 初期処理
      this.init();

    });

  }

  /**
   * 購読解除
   * @memberof Sgke120dComponent
   */
  ngOnDestroy(): void {
    if (!this.dblClickFlg) {
      this.searchService.searchFormValue = null;
    }

    this.onDestroy$.next();
  }

  /**
   * 検索処理
   * @param isFromSearchBtn 
   * @memberof Sgke120dComponent
   */
  search(isFromSearchBtn: boolean = true): void {

    if (isFromSearchBtn) {
      // メッセージクリア
      this.clearErrorMsg();
      // Formの内容をリクエストに設定
      this.requestSgke122a = this.searchConditionForm.getRawValue() as Sgke122aRequest;
    }

    // 検索結果リスト初期化
    this.searchresultList = new Array<Sgke122aResponseSearchresultList>();
    this.showResult = false;

    this.searchService.searchFormValue = cloneDeep(this.requestSgke122a);
    // 検索処理実施
    this.searchService.doSgke122a(this.requestSgke122a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response) {
          if (response.searchresultList?.length > 0) {
            this.searchresultList = response.searchresultList;
            this.showResult = true;
          }
          this.confirmzumiKafusokuRuikei = response.confirmzumiKafusokuRuikei;
          this.hyojiBalanceSum = response.hyojiBalanceSum;
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        }
      }, error => {
      });
  }

  /**
   * 入金突合明細画面遷移処理
   * @param {Sgke122aResponseSearchresultList} row
   * @memberof Sgke120dComponent
   */
  navigateToDetailOnDblClickRow(row: Sgke122aResponseSearchresultList) {

    this.dblClickFlg = true;
    this.router.navigate(['sgke/sgke130d', {
      // モード
      mode: this.mode,
      // 入金突合結果管理番号
      rcvmnyReconciliationresultMno: row.rcvmnyReconciliationresultMno || "",
    }]);

  }

  /**
   * 承認処理
   * @param {Sgke122aResponseSearchresultList[]} selected
   * @memberof Sgke120dComponent
   */
  approval(selected: Sgke122aResponseSearchresultList[]) {
    // メッセージクリア
    this.clearErrorMsg();

    // 承認情報 生成関数
    let requestFunc = function (row: Sgke122aResponseSearchresultList): Sgke123aRequestApprvInfo {
      return {
        rcvmnyReconciliationresultMno: row.rcvmnyReconciliationresultMno,
        rcvmnyreconciliationResultUpdatesequencenumber: row.rcvmnyreconciliationResultUpdatesequencenumber,
        kafusokuAmt: row.kafusokuAmt,
        rcvmnyReconciliationStatuscode: row.rcvmnyReconciliationStatuscode,
      };
    }

    // 承認リクエストDTO作成
    let request: Sgke123aRequest = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      apprvInfo: selected.map(requestFunc)
    }

    // SGKE123A呼び出し
    this.approvalService.doSgke123a(request).pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleResponse,
        error => {
        });
  }

  /**
   * 報告処理
   * @param {Sgke122aResponseSearchresultList[]} selected
   * @memberof Sgke120dComponent
   */
  report(selected: Sgke122aResponseSearchresultList[]) {
    // メッセージクリア
    this.clearErrorMsg();

    // 登録情報 生成関数
    let requestFunc = function (row: Sgke122aResponseSearchresultList): Sgke124aRequestReginf {
      return {
        rcvmnyReconciliationresultMno: row.rcvmnyReconciliationresultMno,
        rcvmnyreconciliationResultUpdatesequencenumber: row.rcvmnyreconciliationResultUpdatesequencenumber,
        kafusokuAmt: row.kafusokuAmt,
        rcvmnyReconciliationStatuscode: row.rcvmnyReconciliationStatuscode,
      };
    }

    // 登録リクエストDTO作成
    let request: Sgke124aRequest = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      reginf: selected.map(requestFunc)
    }

    // SGKE124A呼び出し
    this.reportService.doSgke124a(request).pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleResponse,
        error => {
        });
  }

  /**
   * クリア処理
   * @param {boolean} clearForm フォームのクリア
   * @memberof Sgke120dComponent
   */
  clear(clearForm = true): void {
    this.searchConditionForm.reset();
    this.showResult = false;
    // 検索結果リスト初期化
    this.searchresultList = new Array<Sgke122aResponseSearchresultList>();
    // 検索条件初期化
    if (clearForm) {
      this.searchService.searchFormValue = undefined;
    }
    // メッセージリスト初期化
    this.errorMessageModelArray.length = 0;
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @memberof Sgke120dComponent
   */
  private clearErrorMsg() {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

  /**
   * レスポンス共通処理
   * @private
   * @param {any} response 
   * @memberof Sgke120dComponent
   */
  private handleResponse = (response: any): void => {
    if (response) {
      // メッセージを表示
      this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      // 一覧を再検索
      this.search(false);
    }
  }

  /**
   * 初期処理
   * @private
   * @memberof Sgke120dComponent
   */
  private init() {

    // SZZA012Aのリクエスト情報をもつオブジェクトを定義
    this.requestSzza012a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      businessDayKbn: null,
    };

    // SZZA012A呼び出し
    this.getDateService
      .doSzza012a(this.requestSzza012a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (response) => {
          if (response?.todayDay) {
            this.businessDate = this.timeApiService.convertStringToDate(
              response.todayDay
            );
          }
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        },
        (error) => {
        }
      );

    // sgke121aのリクエスト情報をもつオブジェクトを定義
    this.request121a = {
      // UsedService側で設定するため、ここではnullを設定する
      requestCommon: null
    };

    // SGKE121A呼び出し
    this.initService.doSgke121a(this.request121a).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response?.initialhyojiInfo) {
          this.initialhyojiInfo = response.initialhyojiInfo;
        }

        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      });
  }

}
